import * as React from "react";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilShop } from "../../utils/utilShop";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonInfoSmall } from "../generic/common/ButtonInfoSmall";
import { componentWithProps } from "../generic/componentWithProps";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { OfferBadgeWebBonus } from "../shop/components/OfferBadgeWebBonus";
import { OfferGoldRewardTooltip } from "../shop/components/OfferGoldRewardTooltip";
import { DynamicTooltip, IdTooltipAnchor } from "../tooltip";
export var LeagueRewardSpecialOfferHeader = React.memo(function (_a) {
    var baseGoldValue = _a.baseGoldValue, webBonusGold = _a.webBonusGold, rewards = _a.rewards, subscriptionBonus = _a.subscriptionBonus, primeTimeBonus = _a.primeTimeBonus, bonusGoldPercent = _a.bonusGoldPercent;
    var classBaseName = "dialog-league-reward-special-offer";
    var tooltipComponent = componentWithProps({
        ComponentType: OfferGoldRewardTooltip,
        offer: {
            baseGoldValue: baseGoldValue,
            bonusGoldPercent: bonusGoldPercent,
            primeTimeBonus: primeTimeBonus,
            rewards: rewards,
            subscriptionBonus: subscriptionBonus,
            webBonusGold: webBonusGold,
        },
    });
    var totalGoldAmount = utilShop.calculateOfferTotalGoldAmount({
        baseGoldValue: baseGoldValue,
        primeTimeBonus: primeTimeBonus,
        rewards: rewards,
        subscriptionBonus: subscriptionBonus,
        webBonusGold: webBonusGold,
    });
    return (React.createElement("div", { className: classBaseName + "__heading" },
        React.createElement(DynamicTooltip, { component: tooltipComponent, anchor: IdTooltipAnchor.Left, adjustVertical: -IdTooltipAdjust.XLarge, visibleOnClick: true },
            React.createElement("div", { className: "pos-rel" },
                React.createElement("div", { className: IdStyles.IconAmountContainer + " " + classBaseName + "__main-gold flex flex--guts" },
                    React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                        React.createElement(ButtonInfoSmall, null,
                            React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))),
                    React.createElement("div", { className: classBaseName + "__main-gold-icon" },
                        React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconLarge })),
                    React.createElement(NumberFormat, { amount: totalGoldAmount, className: IdStyles.HeadlineOne })),
                React.createElement(Badge, { position: IdBadgePosition.TopRight },
                    React.createElement(OfferBadgeWebBonus, { bonusGold: webBonusGold, className: "offer-hc__web-bonus", idLoca: IdLoca.goldSum_includeWebBonus }))))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueRewardSpecialOfferHeader.tsx
// module id = 2950
// module chunks = 3